<div class="flex justify-center">
  <p-datepicker
    [ngModel]="ngModelValue()"
    (ngModelChange)="onSelect($event)"
    (onMonthChange)="onMonthNavigate($event)"
    [inline]="true"
    [minDate]="config()?.minDate"
    [maxDate]="config()?.maxDate"
    [defaultDate]="config()!.defaultDate"
    [disabledDates]="config()!.disabledDates"
    [disabledDays]="config()!.disabledDays"
  />
</div>
